import { render, staticRenderFns } from "./Print.vue?vue&type=template&id=3b5ee80e&scoped=true"
import script from "./Print.vue?vue&type=script&lang=js"
export * from "./Print.vue?vue&type=script&lang=js"
import style0 from "./Print.vue?vue&type=style&index=0&id=3b5ee80e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5ee80e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VFlex,VMenu})
